/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {start, registerServiceWorker} from '@salesforce/pwa-kit-react-sdk/ssr/browser/main'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const main = () => {
    // TODO globals are required to get bundle ID but they are normally set on start this action is currently executed twice:
    const data = JSON.parse(document.getElementById('mobify-data').innerHTML)
    // Set all globals sent from the server on the window object.
    Object.entries(data).forEach(([key, value]) => {
        window[key] = value
    })

    const bundlePath = getAssetUrl()
    // The path to your service worker should match what is set up in ssr.js
    return Promise.all([
        start(),
        registerServiceWorker(`/worker.js?bundle=${encodeURIComponent(bundlePath)}`)
    ])
}

main()
